var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAptos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5871 8.06151H16.464C16.2187 8.06151 15.9833 7.95636 15.8181 7.77109L14.9568 6.79967C14.8266 6.65446 14.6464 6.56934 14.4511 6.56934C14.2558 6.56934 14.0755 6.65446 13.9453 6.79967L13.2043 7.63589C12.9639 7.90629 12.6134 8.06652 12.2529 8.06652H0.63092C0.300438 9.00289 0.0851241 9.99934 0 11.0358H10.971C11.1663 11.0358 11.3465 10.9557 11.4817 10.8155L12.5032 9.74897C12.6284 9.61378 12.8087 9.53867 12.9889 9.53867H13.029C13.2243 9.53867 13.4045 9.62379 13.5347 9.769L14.396 10.7404C14.5612 10.9257 14.7966 11.0308 15.0419 11.0308H23.995C23.9099 9.99934 23.6946 8.99788 23.3641 8.0565L18.5871 8.06151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63966 17.2855C6.83495 17.2855 7.01521 17.2054 7.15041 17.0652L8.1719 15.9986C8.30209 15.8634 8.47734 15.7883 8.66261 15.7883H8.70267C8.89796 15.7883 9.08323 15.8734 9.20841 16.0136L10.0697 16.9851C10.2349 17.1703 10.4703 17.2755 10.7156 17.2755H22.8533C23.309 16.3341 23.6395 15.3276 23.8397 14.2711H12.1878C11.9424 14.2711 11.7071 14.1659 11.5418 13.9807L10.6806 13.0193C10.5504 12.8741 10.3701 12.7939 10.1748 12.7939C9.97953 12.7939 9.79426 12.8791 9.66908 13.0193L8.928 13.8555C8.68765 14.1309 8.33714 14.2861 7.97161 14.2861H0.165222C0.365514 15.3427 0.695996 16.3491 1.15166 17.2905L6.63966 17.2855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2473 4.81202C15.4425 4.81202 15.6228 4.7319 15.758 4.5917L16.7795 3.52514C16.9047 3.38994 17.0849 3.31483 17.2702 3.31483H17.3103C17.5055 3.31483 17.6858 3.39996 17.816 3.54517L18.6773 4.52159C18.8425 4.70686 19.0778 4.81202 19.3232 4.81202H21.6316C19.4334 1.88775 15.9383 0 12.0025 0C8.06678 0 4.56668 1.88775 2.36847 4.81202H15.2473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6155 20.2645H7.46086C7.2155 20.2645 6.98016 20.1594 6.81492 19.9741L5.95366 19.0027C5.82347 18.8575 5.64321 18.7773 5.44793 18.7773C5.25264 18.7773 5.06737 18.8625 4.94219 19.0027L4.20111 19.8389C3.96076 20.1143 3.61025 20.2695 3.24471 20.2695H3.19464C5.39285 22.623 8.52241 24.1001 12.0025 24.1001C15.4826 24.1001 18.6071 22.623 20.8103 20.2695L10.6155 20.2645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_4987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0951,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptos);
export default __webpack_public_path__ + "static/media/aptos.c338e71ec108be04261750fb9d806c6e.svg";
export { ForwardRef as ReactComponent };